import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { createSlice } from "@reduxjs/toolkit";
export const accountsApi = createApi({
  reducerPath: "accountsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = window.localStorage.getItem("accessToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
    mode: "cors",
  }),
  tagTypes: ["Accounts", "PeriodicSMS"],
  endpoints: (builder) => ({
    getAllAccounts: builder.query({
      query: () => "fetch_accounts",
      transformErrorResponse: (response, meta, arg) => response.status,
      providesTags: ["Accounts", "ApiKeys"],
    }),
    addNewCustomer: builder.mutation({
      query: (values) => {
        return {
          url: "register_new_client ",
          method: "POST",
          body: values,
        };
      },
      transformErrorResponse: (response, meta, arg) => response.data,
      invalidatesTags: ["Accounts"],
    }),
    getAllApiKeys: builder.query({
      query: () => "fetch_account_api_keys",
      transformErrorResponse: (response, meta, arg) => response.status,
      providesTags: ["ApiKeys"],
    }),
    getAllPeriodicSMS: builder.query({
      query: () => "anniversary-sms",
      transformErrorResponse: (response, meta, args) => response.status,
      providesTags: ["PeriodicSMS"],
    }),
    addPeriodicSMS: builder.mutation({
      query: (values) => {
        return {
          url: "anniversary-sms",
          method: "POST",
          body: values,
        };
      },
      invalidatesTags: ["PeriodicSMS"],
    }),
    deletePeriodicSMS: builder.mutation({
      query: (values) => {
        return {
          url: "anniversary-sms",
          method: "DELETE",
          body: values,
        };
      },
    }),
  }),
});

const accountSlice = createSlice({
  name: "account",
  initialState: {
    api_keys: [],
  },
  reducers: {
    setApiKeys: (state, action) => {
      state.api_keys = action.payload;
    },
  },
});
export default accountSlice.reducer;
export function fetchApiKeys() {
  console.log("Fetching api keys slice");
  return async (dispatch) => {
    try {
      const response = await fetch(
        "https://apis.sema.co.tz/api/fetch_account_api_keys",
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem(
              "accessToken"
            )}`,
          },
        }
      );
      dispatch(accountSlice.actions.setApiKeys(response.data));
      console.log("FETCH API KEYS: ", response);
    } catch (err) {}
  };
}
export const {
  useGetAllAccountsQuery,
  useAddNewCustomerMutation,
  useAddPeriodicSMSMutation,
  useGetAllApiKeysQuery,
  useGetAllPeriodicSMSQuery,
  useDeletePeriodicSMSMutation,
} = accountsApi;
